export default {
  seeNotes: 'See public notes',
  colleaguesWhoKnow: 'Colleagues who know',
  exportActivities: 'Export activities',
};
